import React from 'react'
import { ColorNames } from '../../UIkit/theme/generated/ColorNames.ts'

export const PageColorContext = React.createContext<ColorNames>(ColorNames.CORAL_FIRE)
